import { BsPlusCircleFill, BsAt } from "react-icons/bs";
import { useFormik } from "formik";

const BottomBar = () => {
  const formik = useFormik({
    initialValues: {
      email: "",
      message: "",
    },
    onSubmit: (values) => {
      fetch("https://react-app-35757-default-rtdb.firebaseio.com/contactform.json", {
        method: "POST",
        body: JSON.stringify({
          email: values.email,
          message: values.message,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      alert("Your message was sent successfuly, thank you for contacting me :)");
      formik.resetForm();
    },
  });

  return (
    <form
      className="bottom-bar"
      onSubmit={formik.handleSubmit}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          formik.handleSubmit();
        }
      }}
    >
      <div className="bottom-bar-left">
        <BsAt size="30" className="text-purple-500 dark:shadow-lg mx-2 dark:text-primary" />
        <input type="email" name="email" id="email" placeholder="Your E-mail..." className="bottom-bar-input" value={formik.values.email} onChange={formik.handleChange} />
      </div>
      <div className="bottom-bar-right">
        <BsPlusCircleFill size="22" className="text-purple-500 dark:shadow-lg mx-2 dark:text-primary" />
        <input type="text" name="message" id="message" placeholder="Leave me a message..." className="bottom-bar-input" value={formik.values.message} onChange={formik.handleChange} />
      </div>
    </form>
  );
};

export default BottomBar;
